import {
  SELLERCHATFORM_FETCHITEM_LOAD,
  SELLERCHATFORM_FETCHITEM_SUCCEED,
  SELLERCHATFORM_FETCHITEM_FAIL,
  SELLERCHATFORM_EDITFORM_CHANGE,
  SELLERCHATFORM_ENTER_RESET,
  SELLERCHATFORM_CREATEITEM_LOAD,
  SELLERCHATFORM_CREATEITEM_SUCCEED,
  SELLERCHATFORM_CREATEITEM_FAIL,
  SELLERCHATFORM_EDITITEM_LOAD,
  SELLERCHATFORM_EDITITEM_SUCCEED,
  SELLERCHATFORM_EDITITEM_FAIL,
  SELLERCHATFORM_DELETEITEM_LOAD,
  SELLERCHATFORM_DELETEITEM_SUCCEED,
  SELLERCHATFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERCHATFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case SELLERCHATFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case SELLERCHATFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case SELLERCHATFORM_ENTER_RESET:
      return {}
    case SELLERCHATFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case SELLERCHATFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case SELLERCHATFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case SELLERCHATFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case SELLERCHATFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case SELLERCHATFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case SELLERCHATFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case SELLERCHATFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case SELLERCHATFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case SELLERCHATFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerChatForm.js